/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-07-01 13:33:41
 * @LastEditors: linxi
 * @LastEditTime: 2023-03-01 11:03:49
 */
import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Col, Form, Input, Row, Space, Table } from 'antd'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'

import { ThemeContext } from '../../../theme/ThemeContext'
import { Columns } from './Columuns'
import styles from './statistics.module.css'
import { supplierStatisticsListAsync } from '../OReplaceMakeSlice'
import { useHistory } from 'react-router-dom'
import { Query } from './Query'
import { DateRangeType, getDateRange } from '../../../compnents/form/DateSelect'
import { getChainListAsync } from '../../warehouseStatement/allReport/warehouseChangeReport/warehouseChangeReportSlice'

// 代煎价格
export const ReplaceMakeAStatistics = (props: {
  tabSelect?: any
}): ReactElement => {
  const theme = useContext(ThemeContext)

  const history = useHistory()

  const dispatch = useDispatch<RootDispatch>()

  const [data, setData] = useState<any>([])

  const [total, setTotal] = useState(0)

  const [head, tail] = getDateRange(DateRangeType.ThisMonth)

  const [allData, setAllData] = useState<any>()

  const [params, setParams] = useState<any>({
    current: 1,
    size: 10,
    startTime: head,
    endTime: tail,
    // 默认按已结算筛选，与查询条件默认选中保持一致
    state: '1',
  })

  const [loading, setLoading] = useState(false)

  const [chainList, setChainList] = useState<Array<any>>([])

  const [chainLoaded, setChainLoaded] = useState(false)

  const tenantOffset = chainList?.length ? 1 : 0

  // 总店获取机构名称列表，列表有值才展示机构名称及分店名称列
  useEffect(() => {
    dispatch(getChainListAsync())
      .then(unwrapResult)
      .then((res: any) => {
        setChainList(res || [])
      })
      .finally(() => {
        setChainLoaded(true)
      })
  }, [])

  useEffect(() => {
    // 等机构列表加载完成后再查询，确保总店判断准确
    if (props?.tabSelect == 3 && chainLoaded) {
      setLoading(true)
      dispatch(
        supplierStatisticsListAsync({
          ...params,
          ...(chainList?.length && !params?.chainId
            ? { isHeadquarters: true }
            : {}),
        })
      )
        .then(unwrapResult)
        .then((d: any) => {
          setAllData(d)
          setTotal(d?.res?.total)
          setData(d?.res?.records)
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }, [params, props?.tabSelect, chainList, chainLoaded])

  return (
    <Col
      style={{
        height: 'calc(100% - 0px) ',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Col
        style={{
          flex: 1,
          overflow: 'hidden',
          backgroundColor: theme.pn,
          marginTop: 10,
          borderRadius: 10,
          padding: '20px 15px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Query
          loading={loading}
          chainList={chainList}
          onValueChange={(v: any) => {
            setParams({
              ...params,
              ...v,
              current: 1,
              startTime: v?.timeHead ? v?.timeHead : head,
              endTime: v?.timeTail ? v?.timeTail : tail,
              timeHead: undefined,
              timeTail: undefined,
            })
          }}
        />
        <EditableList
          page={{
            items: data,
            current: params.current || 1,
            size: params.size || 10,
            total,
          }}
          loading={loading}
          style={{ color: theme.tc3 }}
          className={styles.table}
          columns={Columns(
            (params.size || 10) * ((params.current || 1) - 1),
            chainList?.length > 0
          )}
          onChangePage={(current: number, size?: number) => {
            setParams({
              ...params,
              current: current,
              size: size || 10,
            })
          }}
          summary={() => (
            <Table.Summary fixed>
              <Table.Summary.Row className={styles.total}>
                <Table.Summary.Cell index={0}></Table.Summary.Cell>
                {tenantOffset ? (
                  <Table.Summary.Cell index={1}></Table.Summary.Cell>
                ) : null}
                <Table.Summary.Cell
                  index={1 + tenantOffset}
                  className={styles.footingTitle}
                  align='center'
                >
                  合计
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2 + tenantOffset} align='center'>
                  {allData?.recipeCountSum != null
                    ? allData?.recipeCountSum
                    : '0'}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3 + tenantOffset} align='center'>
                  {allData?.recipeAmountSum != null
                    ? allData?.recipeAmountSum?.toFixed(2)
                    : '0.00'}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={4 + tenantOffset} align='center'>
                  {allData?.drugAmountSum != null
                    ? allData?.drugAmountSum?.toFixed(2)
                    : '0.00'}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={5 + tenantOffset} align='center'>
                  {allData?.priceRatioSum != null
                    ? allData?.priceRatioSum?.toFixed(2)
                    : '0.00'}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={6 + tenantOffset} align='center'>
                  {allData?.potionMoneySum != null
                    ? allData?.potionMoneySum?.toFixed(2)
                    : '0.00'}
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          )}
        />
      </Col>
    </Col>
  )
}
